import {TypeImplementation, withSystem, Plugins} from '@packages/systems/wfdl';
import {functionOf, TText, TListOfElement} from '@packages/systems/wfdl-ast';
import {qualify, iconName} from '@packages/systems/wfdl-Qualified';
import {
  dynamoTextualContentToListOfElements,
  dynamoTextualContentToText,
} from '../transformers';
import {TOption} from '@packages/systems/plugins/Option';
import {createDynamoTextOperators} from '../utils';
import {TDynamoPlainText} from '@packages/systems/plugins-utils/DynamoGateway';

export const PlainTextType = TypeImplementation.Custom({
  render: () => null,
  icon: TypeImplementation.IconByName(
    qualify(Plugins.name('Basic'), iconName('Text'))
  ),
});

export const dynamoPlainTextToText = {
  envType: {
    dataType: functionOf(
      withSystem({isBindable: true}, TOption(TDynamoPlainText)),
      TText
    ),
    exported: 'visible',
    implicit: 'prefilledArgs',
  },
  value: dynamoTextualContentToText,
} as const;

export const dynamoPlainTextToListOfElements = {
  envType: {
    dataType: functionOf(
      withSystem({isBindable: true}, TOption(TDynamoPlainText)),
      TListOfElement
    ),
    exported: 'visible',
    implicit: 'prefilledArgs',
  },
  value: dynamoTextualContentToListOfElements,
} as const;

// Generate all text-based operators using the generic utility function
const plainTextOperators = createDynamoTextOperators(TDynamoPlainText);

export const dynamoPlainTextEquals = plainTextOperators.equals;
export const dynamoPlainTextDoesNotEquals = plainTextOperators.doesNotEqual;
export const dynamoPlainTextContains = plainTextOperators.contains;
export const dynamoPlainTextDoesNotContain = plainTextOperators.doesNotContain;
export const dynamoPlainTextStartsWith = plainTextOperators.startsWith;
export const dynamoPlainTextDoesNotStartWith =
  plainTextOperators.doesNotStartWith;
export const dynamoPlainTextEndsWith = plainTextOperators.endsWith;
export const dynamoPlainTextDoesNotEndWith = plainTextOperators.doesNotEndWith;
export const dynamoPlainTextIsSet = plainTextOperators.isSet;
export const dynamoPlainTextIsNotSet = plainTextOperators.isNotSet;
export const dynamoPlainTextOperand = plainTextOperators.operand;
